import {Injectable} from "@angular/core";

import {UsanaObject} from "../usana-object";
import {LoggerService} from "../common/logger.service";
import {SessionService} from "../common/session.service";
import {UrlService} from "../common/url.service";
import { HttpClient } from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {IAoReferralCreditRequest} from "./referral-models";

@Injectable({
    providedIn: 'root'
})
export class ReferralCreditService extends UsanaObject {

    constructor(
        loggerService: LoggerService,
        private http: HttpClient,
        private sessionService: SessionService,
        private urlService: UrlService
    ) {
        super(loggerService);
    }

    getReferralCreditView(): Observable<any> {
        return this.http.get(this.urlService.buildCartUrl("/voucher/referral")).pipe(
            map((response: any) => response),
            catchError((error: any) => throwError(error))
        );
    }

    getReferralCreditBalance(): Observable<any> {
        return this.http.get(this.urlService.buildCartUrl("/voucher/referral/current")).pipe(
            map((response: any) => response),
            catchError((error: any) => throwError(error))
        );
    }

    toggleReferralCredit(aoReferralCredit: IAoReferralCreditRequest): Observable<any> {
        return this.http.post(this.urlService.buildCartUrl("/voucher/referral/ao"), aoReferralCredit)
            .pipe(
                map((response: any) => response),
                catchError((error: any) => throwError(error))
            );
    }

    getUseReferralCredit(): Observable<any> {
        return this.http.get(this.urlService.buildCartUrl("/voucher/referral/ao")).pipe(
            map((response: any) => response),
            catchError((error: any) => throwError(error))
        );
    }

}
